import React from 'react';
import { Button } from './ui/button';
import {
  Plus, ListPlus, Settings, CalendarClock, Trash2,
} from 'lucide-react';
import { CollapsibleSection } from './CollapsibleSection';

export const NextMeetingSection = ({
  items, isAdmin, navigate, emailSettings,
  onAddDeal, onAddCustom, onRemove, onOpenSettings,
}) => {
  const actions = (
    <div className="flex items-center gap-2 flex-wrap shrink-0">
      <Button onClick={(e) => { e.stopPropagation(); onAddDeal(); }} data-testid="next-add-deal-btn"
        variant="outline" className="border-border text-foreground rounded-sm text-xs h-8 px-3">
        <Plus className="w-3.5 h-3.5 mr-1" /> Add Deal
      </Button>
      <Button onClick={(e) => { e.stopPropagation(); onAddCustom(); }} data-testid="next-add-custom-btn"
        variant="outline" className="border-border text-foreground rounded-sm text-xs h-8 px-3">
        <ListPlus className="w-3.5 h-3.5 mr-1" /> Add Item
      </Button>
      {isAdmin && (
        <button onClick={(e) => { e.stopPropagation(); onOpenSettings(); }} title="Automated agenda email settings" data-testid="next-email-settings-btn"
          className="h-8 px-2 text-muted-foreground hover:text-foreground border border-border rounded-sm transition-colors flex items-center gap-1.5 text-xs">
          <Settings className="w-3.5 h-3.5" /> Auto-Email
        </button>
      )}
    </div>
  );

  return (
    <CollapsibleSection
      storageKey="meeting.next"
      icon={CalendarClock}
      iconClass="text-blue-400"
      title={`Following Meeting (${items.length})`}
      right={actions}
      className="border-blue-500/25"
      testId="next-meeting-section"
    >
      <div className="px-4 py-2 border-b border-border">
        <p className="text-[11px] text-muted-foreground" data-testid="next-meeting-email-status">
          Once the agenda email has gone out{emailSettings?.enabled ? ` (${emailSettings.send_time}, Mon–Fri)` : ''}, every new deal automatically queues here — until that meeting is finalized. So the emailed agenda always matches what's discussed.
        </p>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-6">Nothing queued for the following meeting yet.</p>
      ) : items.map(item => (
        <div key={item.id} className="flex items-center gap-3 px-4 py-2.5 border-b border-border last:border-b-0"
          data-testid={`next-item-${item.id}`}>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              {item.item_type === 'custom' ? (
                <>
                  <span className="text-sm font-medium text-foreground">{item.title}</span>
                  <span className="text-[9px] font-mono text-purple-400 bg-purple-400/10 border border-purple-400/20 rounded px-1.5 py-0.5">Agenda</span>
                </>
              ) : (
                <>
                  <button onClick={() => navigate(`/projects/${item.project_id}`)}
                    className="text-sm font-medium text-foreground hover:text-blue-400 transition-colors truncate">
                    {item.project_name}
                  </button>
                  <span className="text-[9px] font-mono text-muted-foreground bg-secondary border border-border rounded px-1.5 py-0.5">
                    {item.stage_label}
                  </span>
                </>
              )}
            </div>
            <p className="text-[10px] text-muted-foreground mt-0.5">
              {item.owner_name ? `Owner: ${item.owner_name} · ` : ''}Added by {item.added_by}
            </p>
          </div>
          <button onClick={() => onRemove(item.id)} title="Remove" data-testid={`next-remove-${item.id}`}
            className="text-muted-foreground/30 hover:text-red-400 transition-colors p-1">
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </CollapsibleSection>
  );
};
